import {
    CREATEGENERALPAINASSESSMENTPAINNATURE,
    CREATEGENERALPAINASSESSMENTPAINONSET,
    CREATEGENERALPAINASSESSMENTPAINVARIATION,
    CREATEGENERALPAINASSESSMENTSEVERITY,
    CREATEGENERALPAINASSESSMENTSTATUS,
    DELETEGENERALPAINASSESSMENTPAINNATURE,
    DELETEGENERALPAINASSESSMENTPAINONSET,
    DELETEGENERALPAINASSESSMENTPAINVARIATION,
    DELETEGENERALPAINASSESSMENTSEVERITY,
    DELETEGENERALPAINASSESSMENTSTATUS,
    GETGENERALPAINASSESSMENTPAINNATURE,
    GETGENERALPAINASSESSMENTPAINONSET,
    GETGENERALPAINASSESSMENTPAINVARIATION,
    GETGENERALPAINASSESSMENTSEVERITY,
    GETGENERALPAINASSESSMENTSTATUS,
    UPDATEGENERALPAINASSESSMENTPAINNATURE,
    UPDATEGENERALPAINASSESSMENTPAINONSET,
    UPDATEGENERALPAINASSESSMENTPAINVARIATION,
    UPDATEGENERALPAINASSESSMENTSEVERITY,
    UPDATEGENERALPAINASSESSMENTSTATUS,
    GETGENERALCOMPLAINTCHILDILLNESS,
    CREATEGENERALCOMPLAINTCHILDILLNESS,
    DELETEGENERALCOMPLAINTCHILDILLNESS,
    UPDATEGENERALCOMPLAINTCHILDILLNESS,
    GETGENERALCOMPLAINTADULTILLNESS,
    CREATEGENERALCOMPLAINTADULTILLNESS,
    DELETEGENERALCOMPLAINTADULTILLNESS,
    UPDATEGENERALCOMPLAINTADULTILLNESS,
    GETGENERALCOMPLAINTHEALTHMAINT,
    CREATEGENERALCOMPLAINTHEALTHMAINT,
    DELETEGENERALCOMPLAINTHEALTHMAINT,
    UPDATEGENERALCOMPLAINTHEALTHMAINT,
    GETGENERALCOMPLAINTRELATION,
    CREATEGENERALCOMPLAINTRELATION,
    DELETEGENERALCOMPLAINTRELATION,
    UPDATEGENERALCOMPLAINTRELATION,
    GETGENERALCOMPLAINTAPPETITE,
    CREATEGENERALCOMPLAINTAPPETITE,
    UPDATEGENERALCOMPLAINTAPPETITE,
    DELETEGENERALCOMPLAINTAPPETITE,
    GETGENERALCOMPLAINTDIGESTIVETRACT,
    CREATEGENERALCOMPLAINTDIGESTIVETRACT,
    UPDATEGENERALCOMPLAINTDIGESTIVETRACT,
    DELETEGENERALCOMPLAINTDIGESTIVETRACT,
    GETGENERALCOMPLAINTBOWEL,
    CREATEGENERALCOMPLAINTBOWEL,
    UPDATEGENERALCOMPLAINTBOWEL,
    DELETEGENERALCOMPLAINTBOWEL,
    GETGENERALCOMPLAINTSLEEP,
    CREATEGENERALCOMPLAINTSLEEP,
    UPDATEGENERALCOMPLAINTSLEEP,
    DELETEGENERALCOMPLAINTSLEEP,
    GETGENERALCOMPLAINTADDICTIONS,
    CREATEGENERALCOMPLAINTADDICTIONS,
    UPDATEGENERALCOMPLAINTADDICTIONS,
    DELETEGENERALCOMPLAINTADDICTIONS,
    GETGENERALCOMPLAINTHIGHRISK,
    CREATEGENERALCOMPLAINTHIGHRISK,
    UPDATEGENERALCOMPLAINTHIGHRISK,
    DELETEGENERALCOMPLAINTHIGHRISK,
    GETGENERALCOMPLAINTWORKPOSITION,
    CREATEGENERALCOMPLAINTWORKPOSITION,
    UPDATEGENERALCOMPLAINTWORKPOSITION,
    DELETEGENERALCOMPLAINTWORKPOSITION,
    GETGENERALCOMPLAINTWORKNATURE,
    CREATEGENERALCOMPLAINTWORKNATURE,
    UPDATEGENERALCOMPLAINTWORKNATURE,
    DELETEGENERALCOMPLAINTWORKNATURE,
    GETGENERALCOMPLAINTALLOPATHICMEDI,
    CREATEGENERALCOMPLAINTALLOPATHICMEDI,
    UPDATEGENERALCOMPLAINTALLOPATHICMEDI,
    DELETEGENERALCOMPLAINTALLOPATHICMEDI,
    GETGENERALCOMPLAINTAYURVEDAMEDI,
    CREATEGENERALCOMPLAINTAYURVEDAMEDI,
    UPDATEGENERALCOMPLAINTAYURVEDAMEDI,
    DELETEGENERALCOMPLAINTAYURVEDAMEDI,
    GETGENERALCOMPLAINTHOMEOPATHICMEDI,
    CREATEGENERALCOMPLAINTHOMEOPATHICMEDI,
    UPDATEGENERALCOMPLAINTHOMEOPATHICMEDI,
    DELETEGENERALCOMPLAINTHOMEOPATHICMEDI,
    GETGENERALCOMPLAINTOTHERMEDI,
    CREATEGENERALCOMPLAINTOTHERMEDI,
    UPDATEGENERALCOMPLAINTOTHERMEDI,
    DELETEGENERALCOMPLAINTOTHERMEDI,
    GETGENERALCOMPLAINTANXIETY,
    CREATEGENERALCOMPLAINTANXIETY,
    UPDATEGENERALCOMPLAINTANXIETY,
    DELETEGENERALCOMPLAINTANXIETY,
    GETGENERALCOMPLAINTDEPRESSION,
    CREATEGENERALCOMPLAINTDEPRESSION,
    UPDATEGENERALCOMPLAINTDEPRESSION,
    DELETEGENERALCOMPLAINTDEPRESSION,
    GETGENERALCOMPLAINTIRRITABILITY,
    CREATEGENERALCOMPLAINTIRRITABILITY,
    UPDATEGENERALCOMPLAINTIRRITABILITY,
    DELETEGENERALCOMPLAINTIRRITABILITY,
    GETGENERALCOMPLAINTEUPHORIA,
    CREATEGENERALCOMPLAINTEUPHORIA,
    UPDATEGENERALCOMPLAINTEUPHORIA,
    DELETEGENERALCOMPLAINTEUPHORIA,
    GETGENERALCOMPLAINTOBSESSION,
    CREATEGENERALCOMPLAINTOBSESSION,
    UPDATEGENERALCOMPLAINTOBSESSION,
    DELETEGENERALCOMPLAINTOBSESSION,
    GETGENERALCOMPLAINTNEUROSIS,
    CREATEGENERALCOMPLAINTNEUROSIS,
    UPDATEGENERALCOMPLAINTNEUROSIS,
    DELETEGENERALCOMPLAINTNEUROSIS,
    GETGENERALCOMPLAINTDEPERSONALIZATION,
    CREATEGENERALCOMPLAINTDEPERSONALIZATION,
    UPDATEGENERALCOMPLAINTDEPERSONALIZATION,
    DELETEGENERALCOMPLAINTDEPERSONALIZATION,
    GETGENERALCOMPLAINTMENSTRUALCYCLE,
    CREATEGENERALCOMPLAINTMENSTRUALCYCLE,
    UPDATEGENERALCOMPLAINTMENSTRUALCYCLE,
    DELETEGENERALCOMPLAINTMENSTRUALCYCLE,
    GETGENERALCOMPLAINTNATUREOFDELIVERY,
    CREATEGENERALCOMPLAINTNATUREOFDELIVERY,
    UPDATEGENERALCOMPLAINTNATUREOFDELIVERY,
    DELETEGENERALCOMPLAINTNATUREOFDELIVERY,
    GETGENERALEXAMSIGNOFDISTRESS,
    CREATEGENERALEXAMSIGNOFDISTRESS,
    UPDATEGENERALEXAMSIGNOFDISTRESS,
    DELETEGENERALEXAMSIGNOFDISTRESS,
    GETGENERALEXAMBODYTYPE,
    CREATEGENERALEXAMBODYTYPE,
    UPDATEGENERALEXAMBODYTYPE,
    DELETEGENERALEXAMBODYTYPE,
    GETGENERALEXAMPOSTURE,
    CREATEGENERALEXAMPOSTURE,
    UPDATEGENERALEXAMPOSTURE,
    DELETEGENERALEXAMPOSTURE,
    GETGENERALEXAMGAIT,
    CREATEGENERALEXAMGAIT,
    UPDATEGENERALEXAMGAIT,
    DELETEGENERALEXAMGAIT,
    GETGENERALEXAMBODYMOVEMENTS,
    CREATEGENERALEXAMBODYMOVEMENTS,
    UPDATEGENERALEXAMBODYMOVEMENTS,
    DELETEGENERALEXAMBODYMOVEMENTS,
    GETGENERALEXAMBODY,
    CREATEGENERALEXAMBODY,
    UPDATEGENERALEXAMBODY,
    DELETEGENERALEXAMBODY,
    GETGENERALEXAMAFFECTANDMOOD,
    CREATEGENERALEXAMAFFECTANDMOOD,
    UPDATEGENERALEXAMAFFECTANDMOOD,
    DELETEGENERALEXAMAFFECTANDMOOD,
    GETGENERALEXAMSPEECH,
    CREATEGENERALEXAMSPEECH,
    UPDATEGENERALEXAMSPEECH,
    DELETEGENERALEXAMSPEECH,
    GETGENERALEXAMHAIRCOLOR,
    CREATEGENERALEXAMHAIRCOLOR,
    UPDATEGENERALEXAMHAIRCOLOR,
    DELETEGENERALEXAMHAIRCOLOR,
    GETGENERALEXAMHAIRDISTRIBUTION,
    CREATEGENERALEXAMHAIRDISTRIBUTION,
    UPDATEGENERALEXAMHAIRDISTRIBUTION,
    DELETEGENERALEXAMHAIRDISTRIBUTION,
    GETGENERALEXAMHAIRTEXTURE,
    CREATEGENERALEXAMHAIRTEXTURE,
    UPDATEGENERALEXAMHAIRTEXTURE,
    DELETEGENERALEXAMHAIRTEXTURE,
    GETGENERALEXAMLUBRICATION,
    CREATEGENERALEXAMLUBRICATION,
    UPDATEGENERALEXAMLUBRICATION,
    DELETEGENERALEXAMLUBRICATION,
    GETGENERALEXAMSCALP,
    CREATEGENERALEXAMSCALP,
    UPDATEGENERALEXAMSCALP,
    DELETEGENERALEXAMSCALP,
    GETGENERALEXAMHEADPOSITION,
    CREATEGENERALEXAMHEADPOSITION,
    UPDATEGENERALEXAMHEADPOSITION,
    DELETEGENERALEXAMHEADPOSITION,
    GETGENERALEXAMHEADSHAPE,
    CREATEGENERALEXAMHEADSHAPE,
    UPDATEGENERALEXAMHEADSHAPE,
    DELETEGENERALEXAMHEADSHAPE,
    GETGENERALEXAMFACIALFEATURES,
    CREATEGENERALEXAMFACIALFEATURES,
    UPDATEGENERALEXAMFACIALFEATURES,
    DELETEGENERALEXAMFACIALFEATURES,
    GETGENERALEXAMEXTERNALEYEPOSITION,
    CREATEGENERALEXAMEXTERNALEYEPOSITION,
    UPDATEGENERALEXAMEXTERNALEYEPOSITION,
    DELETEGENERALEXAMEXTERNALEYEPOSITION,
    GETGENERALEXAMLACRIMALAPPARATUS,
    CREATEGENERALEXAMLACRIMALAPPARATUS,
    UPDATEGENERALEXAMLACRIMALAPPARATUS,
    DELETEGENERALEXAMLACRIMALAPPARATUS,
    GETGENERALEXAMCONJUCTIVASCLEARCOLOR,
    CREATEGENERALEXAMCONJUCTIVASCLEARCOLOR,
    UPDATEGENERALEXAMCONJUCTIVASCLEARCOLOR,
    DELETEGENERALEXAMCONJUCTIVASCLEARCOLOR,
    GETGENERALEXAMEXTRAOCULARMOVEMENTS,
    CREATEGENERALEXAMEXTRAOCULARMOVEMENTS,
    UPDATEGENERALEXAMEXTRAOCULARMOVEMENTS,
    DELETEGENERALEXAMEXTRAOCULARMOVEMENTS,
    GETGENERALEXAMNECKLYMPHNODE,
    CREATEGENERALEXAMNECKLYMPHNODE,
    UPDATEGENERALEXAMNECKLYMPHNODE,
    DELETEGENERALEXAMNECKLYMPHNODE,
    GETGENERALEXAMGENERALLOOK,
    CREATEGENERALEXAMGENERALLOOK,
    UPDATEGENERALEXAMGENERALLOOK,
    DELETEGENERALEXAMGENERALLOOK,
    GETGENERALEXAMNUTRITION,
    CREATEGENERALEXAMNUTRITION,
    UPDATEGENERALEXAMNUTRITION,
    DELETEGENERALEXAMNUTRITION,
    GETGENERALEXAMANEAMIA,
    CREATEGENERALEXAMANEAMIA,
    UPDATEGENERALEXAMANEAMIA,
    DELETEGENERALEXAMANEAMIA,
    GETGENERALEXAMNECKANDVEIN,
    CREATEGENERALEXAMNECKANDVEIN,
    UPDATEGENERALEXAMNECKANDVEIN,
    DELETEGENERALEXAMNECKANDVEIN,
    GETGENERALEXAMLYMPHNODE,
    CREATEGENERALEXAMLYMPHNODE,
    UPDATEGENERALEXAMLYMPHNODE,
    DELETEGENERALEXAMLYMPHNODE,

} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEGENERALPAINASSESSMENTSTATUS:
            return {
                ...state,
                generalpainassesmentstatusSaveStatus: action.payload.success,
            }
        case GETGENERALPAINASSESSMENTSTATUS:
            return {
                ...state,
                generalpainassesmentstatusList: action.payload.data,
            }
        case UPDATEGENERALPAINASSESSMENTSTATUS:
            return {
                ...state,
                generalpainassesmentstatusUpdateStatus: action.payload.success,
            }

        case DELETEGENERALPAINASSESSMENTSTATUS:
            return {
                ...state,
                generalpainassesmentstatusDeleteStatus: action.payload.success,
            }
        case CREATEGENERALPAINASSESSMENTSEVERITY:
            return {
                ...state,
                generalpainassesmentstatusSaveStatus: action.payload.success,
            }
        case GETGENERALPAINASSESSMENTSEVERITY:
            return {
                ...state,
                generalpainassesmentseverityList: action.payload.data,
            }
        case UPDATEGENERALPAINASSESSMENTSEVERITY:
            return {
                ...state,
                generalpainassesmentseverityUpdateStatus: action.payload.success,
            }

        case DELETEGENERALPAINASSESSMENTSEVERITY:
            return {
                ...state,
                generalpainassesmentseverityDeleteStatus: action.payload.success,
            }
        case CREATEGENERALPAINASSESSMENTPAINNATURE:
            return {
                ...state,
                generalpainassesmentpainnatureSaveStatus: action.payload.success,
            }
        case GETGENERALPAINASSESSMENTPAINNATURE:
            return {
                ...state,
                generalpainassesmentpainnatureList: action.payload.data,
            }
        case UPDATEGENERALPAINASSESSMENTPAINNATURE:
            return {
                ...state,
                generalpainassesmentpainnatureUpdateStatus: action.payload.success,
            }

        case DELETEGENERALPAINASSESSMENTPAINNATURE:
            return {
                ...state,
                generalpainassesmentpainnatureDeleteStatus: action.payload.success,
            }

        case CREATEGENERALPAINASSESSMENTPAINONSET:
            return {
                ...state,
                generalpainassesmentpainonsetSaveStatus: action.payload.success,
            }
        case GETGENERALPAINASSESSMENTPAINONSET:
            return {
                ...state,
                generalpainassesmentpainonsetList: action.payload.data,
            }
        case UPDATEGENERALPAINASSESSMENTPAINONSET:
            return {
                ...state,
                generalpainassesmentpainonsetUpdateStatus: action.payload.success,
            }

        case DELETEGENERALPAINASSESSMENTPAINONSET:
            return {
                ...state,
                generalpainassesmentpainonsetDeleteStatus: action.payload.success,
            }
        case CREATEGENERALPAINASSESSMENTPAINVARIATION:
            return {
                ...state,
                generalpainassesmentpainvariationSaveStatus: action.payload.success,
            }
        case GETGENERALPAINASSESSMENTPAINVARIATION:
            return {
                ...state,
                generalpainassesmentpainvariationList: action.payload.data,
            }
        case UPDATEGENERALPAINASSESSMENTPAINVARIATION:
            return {
                ...state,
                generalpainassesmentpainvariationUpdateStatus: action.payload.success,
            }

        case DELETEGENERALPAINASSESSMENTPAINVARIATION:
            return {
                ...state,
                generalpainassesmentpainvariationDeleteStatus: action.payload.success,
            }
        case CREATEGENERALCOMPLAINTCHILDILLNESS:
            return {
                ...state,
                generalComplaintChildillnessSaveStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTCHILDILLNESS:
            return {
                ...state,
                generalComplaintChildillnessList: action.payload.data,
            }
        case UPDATEGENERALCOMPLAINTCHILDILLNESS:
            return {
                ...state,
                generalComplaintChildillnessUpdateStatus: action.payload.success,
            }

        case DELETEGENERALCOMPLAINTCHILDILLNESS:
            return {
                ...state,
                generalComplaintChildillnessDeleteStatus: action.payload.success,
            }
        case CREATEGENERALCOMPLAINTADULTILLNESS:
            return {
                ...state,
                generalComplaintAdultillnessSaveStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTADULTILLNESS:
            return {
                ...state,
                generalComplaintAdultillnessList: action.payload.data,
            }
        case UPDATEGENERALCOMPLAINTADULTILLNESS:
            return {
                ...state,
                generalComplaintAdultillnessUpdateStatus: action.payload.success,
            }

        case DELETEGENERALCOMPLAINTADULTILLNESS:
            return {
                ...state,
                generalComplaintAdultillnessDeleteStatus: action.payload.success,
            }
        case CREATEGENERALCOMPLAINTHEALTHMAINT:
            return {
                ...state,
                generalComplaintHealthMainSaveStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTHEALTHMAINT:
            return {
                ...state,
                generalComplaintHealthMainList: action.payload.data,
            }
        case UPDATEGENERALCOMPLAINTHEALTHMAINT:
            return {
                ...state,
                generalComplaintHealthMainUpdateStatus: action.payload.success,
            }

        case DELETEGENERALCOMPLAINTHEALTHMAINT:
            return {
                ...state,
                generalComplaintHealthMainDeleteStatus: action.payload.success,
            }

        case CREATEGENERALCOMPLAINTRELATION:
            return {
                ...state,
                generalComplaintRelationSaveStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTRELATION:
            return {
                ...state,
                generalComplaintRelationList: action.payload.data,
            }
        case UPDATEGENERALCOMPLAINTRELATION:
            return {
                ...state,
                generalComplaintRelationUpdateStatus: action.payload.success,
            }

        case DELETEGENERALCOMPLAINTRELATION:
            return {
                ...state,
                generalComplaintRelationDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTAPPETITE:
            return {
                ...state,
                generalComplaintAppetiteList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTAPPETITE:
            return {
                ...state,
                generalComplaintAppetiteSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTAPPETITE:
            return {
                ...state,
                generalComplaintAppetiteUpdateStatus: action.payload.success,
            }

        case DELETEGENERALCOMPLAINTAPPETITE:
            return {
                ...state,
                generalComplaintAppetiteDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTDIGESTIVETRACT:
            return {
                ...state,
                generalComplaintDigestiveTractList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTDIGESTIVETRACT:
            return {
                ...state,
                generalComplaintDigestiveTractSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTDIGESTIVETRACT:
            return {
                ...state,
                generalComplaintDigestiveTractUpdateStatus: action.payload.success,
            }

        case DELETEGENERALCOMPLAINTDIGESTIVETRACT:
            return {
                ...state,
                generalComplaintDigestiveTractDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTBOWEL:
            return {
                ...state,
                generalComplaintBowelList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTBOWEL:
            return {
                ...state,
                generalComplaintBowelSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTBOWEL:
            return {
                ...state,
                generalComplaintBowelUpdateStatus: action.payload.success,
            }

        case DELETEGENERALCOMPLAINTBOWEL:
            return {
                ...state,
                generalComplaintBowelDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTSLEEP:
            return {
                ...state,
                generalComplaintSleepList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTSLEEP:
            return {
                ...state,
                generalComplaintSleepSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTSLEEP:
            return {
                ...state,
                generalComplaintSleepUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTSLEEP:
            return {
                ...state,
                generalComplaintSleepDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTADDICTIONS:
            return {
                ...state,
                generalComplaintAddictionsList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTADDICTIONS:
            return {
                ...state,
                generalComplaintAddictionsSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTADDICTIONS:
            return {
                ...state,
                generalComplaintAddictionsUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTADDICTIONS:
            return {
                ...state,
                generalComplaintAddictionsDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTHIGHRISK:
            return {
                ...state,
                generalComplaintHighRiskList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTHIGHRISK:
            return {
                ...state,
                generalComplaintHighRiskSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTHIGHRISK:
            return {
                ...state,
                generalComplaintHighRiskUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTHIGHRISK:
            return {
                ...state,
                generalComplaintHighRiskDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTWORKPOSITION:
            return {
                ...state,
                generalComplaintWorkPositionList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTWORKPOSITION:
            return {
                ...state,
                generalComplaintWorkPositionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTWORKPOSITION:
            return {
                ...state,
                generalComplaintWorkPositionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTWORKPOSITION:
            return {
                ...state,
                generalComplaintWorkPositionDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTWORKNATURE:
            return {
                ...state,
                generalComplaintWorkNatureList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTWORKNATURE:
            return {
                ...state,
                generalComplaintWorkNatureSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTWORKNATURE:
            return {
                ...state,
                generalComplaintWorkNatureUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTWORKNATURE:
            return {
                ...state,
                generalComplaintWorkNatureDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTALLOPATHICMEDI:
            return {
                ...state,
                generalComplaintAllopathicmediList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTALLOPATHICMEDI:
            return {
                ...state,
                generalComplaintAllopathicmediSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTALLOPATHICMEDI:
            return {
                ...state,
                generalComplaintAllopathicmediUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTALLOPATHICMEDI:
            return {
                ...state,
                generalComplaintAllopathicmediDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTAYURVEDAMEDI:
            return {
                ...state,
                generalComplaintAyurvedamediList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTAYURVEDAMEDI:
            return {
                ...state,
                generalComplaintAyurvedamediSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTAYURVEDAMEDI:
            return {
                ...state,
                generalComplaintAyurvedamediUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTAYURVEDAMEDI:
            return {
                ...state,
                generalComplaintAyurvedamediDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTHOMEOPATHICMEDI:
            return {
                ...state,
                generalComplaintHomeopathicmediList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTHOMEOPATHICMEDI:
            return {
                ...state,
                generalComplaintHomeopathicmediSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTHOMEOPATHICMEDI:
            return {
                ...state,
                generalComplaintHomeopathicmediUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTHOMEOPATHICMEDI:
            return {
                ...state,
                generalComplaintHomeopathicmediDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTOTHERMEDI:
            return {
                ...state,
                generalComplaintOtherMediList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTOTHERMEDI:
            return {
                ...state,
                generalComplaintOtherMediSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTOTHERMEDI:
            return {
                ...state,
                generalComplaintOtherMediUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTOTHERMEDI:
            return {
                ...state,
                generalComplaintOtherMediDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTANXIETY:
            return {
                ...state,
                generalComplaintAnxietyList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTANXIETY:
            return {
                ...state,
                generalComplaintAnxietySaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTANXIETY:
            return {
                ...state,
                generalComplaintAnxietyUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTANXIETY:
            return {
                ...state,
                generalComplaintAnxietyDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTDEPRESSION:
            return {
                ...state,
                generalComplaintDepressionList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTDEPRESSION:
            return {
                ...state,
                generalComplaintDepressionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTDEPRESSION:
            return {
                ...state,
                generalComplaintDepressionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTDEPRESSION:
            return {
                ...state,
                generalComplaintDepressionDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTIRRITABILITY:
            return {
                ...state,
                generalComplaintIrritabilityList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTIRRITABILITY:
            return {
                ...state,
                generalComplaintIrritabilitySaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTIRRITABILITY:
            return {
                ...state,
                generalComplaintIrritabilityUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTIRRITABILITY:
            return {
                ...state,
                generalComplaintIrritabilityDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTEUPHORIA:
            return {
                ...state,
                generalComplaintEuphoriaList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTEUPHORIA:
            return {
                ...state,
                generalComplaintEuphoriaSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTEUPHORIA:
            return {
                ...state,
                generalComplaintEuphoriaUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTEUPHORIA:
            return {
                ...state,
                generalComplaintEuphoriaDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTOBSESSION:
            return {
                ...state,
                generalComplaintObsessionList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTOBSESSION:
            return {
                ...state,
                generalComplaintObsessionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTOBSESSION:
            return {
                ...state,
                generalComplaintObsessionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTOBSESSION:
            return {
                ...state,
                generalComplaintObsessionDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTNEUROSIS:
            return {
                ...state,
                generalComplaintNeurosisList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTNEUROSIS:
            return {
                ...state,
                generalComplaintNeurosisSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTNEUROSIS:
            return {
                ...state,
                generalComplaintNeurosisUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTNEUROSIS:
            return {
                ...state,
                generalComplaintNeurosisDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTDEPERSONALIZATION:
            return {
                ...state,
                generalComplaintDepersonalizationList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTDEPERSONALIZATION:
            return {
                ...state,
                generalComplaintDepersonalizationSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTDEPERSONALIZATION:
            return {
                ...state,
                generalComplaintDepersonalizationUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTDEPERSONALIZATION:
            return {
                ...state,
                generalComplaintDepersonalizationDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTMENSTRUALCYCLE:
            return {
                ...state,
                generalComplaintMenstrualCycleList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTMENSTRUALCYCLE:
            return {
                ...state,
                generalComplaintMenstrualCycleSaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTMENSTRUALCYCLE:
            return {
                ...state,
                generalComplaintMenstrualCycleUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTMENSTRUALCYCLE:
            return {
                ...state,
                generalComplaintMenstrualCycleDeleteStatus: action.payload.success,
            }
        case GETGENERALCOMPLAINTNATUREOFDELIVERY:
            return {
                ...state,
                generalComplaintNatureOfDeliveryList: action.payload.data,
            }
        case CREATEGENERALCOMPLAINTNATUREOFDELIVERY:
            return {
                ...state,
                generalComplaintNatureOfDeliverySaveStatus: action.payload.success,
            }
        case UPDATEGENERALCOMPLAINTNATUREOFDELIVERY:
            return {
                ...state,
                generalComplaintNatureOfDeliveryUpdateStatus: action.payload.success,
            }
        case DELETEGENERALCOMPLAINTNATUREOFDELIVERY:
            return {
                ...state,
                generalComplaintNatureOfDeliveryDeleteStatus: action.payload.success,
            }

        case GETGENERALEXAMSIGNOFDISTRESS:
            return {
                ...state,
                generalExamSignsOfDistressList: action.payload.data,
            }
        case CREATEGENERALEXAMSIGNOFDISTRESS:
            return {
                ...state,
                generalExamSignsOfDistressSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMSIGNOFDISTRESS:
            return {
                ...state,
                generalExamSignsOfDistressUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMSIGNOFDISTRESS:
            return {
                ...state,
                generalExamSignsOfDistressDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMBODYTYPE:
            return {
                ...state,
                generalExamBodyTypeList: action.payload.data,
            }
        case CREATEGENERALEXAMBODYTYPE:
            return {
                ...state,
                generalExamBodyTypeSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMBODYTYPE:
            return {
                ...state,
                generalExamBodyTypeUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMBODYTYPE:
            return {
                ...state,
                generalExamBodyTypeDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMPOSTURE:
            return {
                ...state,
                generalExamPostureList: action.payload.data,
            }
        case CREATEGENERALEXAMPOSTURE:
            return {
                ...state,
                generalExamPostureSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMPOSTURE:
            return {
                ...state,
                generalExamPostureUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMPOSTURE:
            return {
                ...state,
                generalExamPostureDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMGAIT:
            return {
                ...state,
                generalExamGaitList: action.payload.data,
            }
        case CREATEGENERALEXAMGAIT:
            return {
                ...state,
                generalExamGaitSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMGAIT:
            return {
                ...state,
                generalExamGaitUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMGAIT:
            return {
                ...state,
                generalExamGaitDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMBODYMOVEMENTS:
            return {
                ...state,
                generalExamBodyMovementsList: action.payload.data,
            }
        case CREATEGENERALEXAMBODYMOVEMENTS:
            return {
                ...state,
                generalExamBodyMovementsSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMBODYMOVEMENTS:
            return {
                ...state,
                generalExamBodyMovementsUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMBODYMOVEMENTS:
            return {
                ...state,
                generalExamBodyMovementsDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMBODY:
            return {
                ...state,
                generalExamBodyList: action.payload.data,
            }
        case CREATEGENERALEXAMBODY:
            return {
                ...state,
                generalExamBodySaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMBODY:
            return {
                ...state,
                generalExamBodyUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMBODY:
            return {
                ...state,
                generalExamBodyDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMAFFECTANDMOOD:
            return {
                ...state,
                generalExamAffectandMoodList: action.payload.data,
            }
        case CREATEGENERALEXAMAFFECTANDMOOD:
            return {
                ...state,
                generalExamAffectandMoodSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMAFFECTANDMOOD:
            return {
                ...state,
                generalExamAffectandMoodUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMAFFECTANDMOOD:
            return {
                ...state,
                generalExamAffectandMoodDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMSPEECH:
            return {
                ...state,
                generalExamSpeechList: action.payload.data,
            }
        case CREATEGENERALEXAMSPEECH:
            return {
                ...state,
                generalExamSpeechSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMSPEECH:
            return {
                ...state,
                generalExamSpeechUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMSPEECH:
            return {
                ...state,
                generalExamSpeechDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMHAIRCOLOR:
            return {
                ...state,
                generalExamHairColorList: action.payload.data,
            }
        case CREATEGENERALEXAMHAIRCOLOR:
            return {
                ...state,
                generalExamHairColorSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMHAIRCOLOR:
            return {
                ...state,
                generalExamHairColorUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMHAIRCOLOR:
            return {
                ...state,
                generalExamHairColorDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMHAIRDISTRIBUTION:
            return {
                ...state,
                generalExamHairDistributionList: action.payload.data,
            }
        case CREATEGENERALEXAMHAIRDISTRIBUTION:
            return {
                ...state,
                generalExamHairDistributionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMHAIRDISTRIBUTION:
            return {
                ...state,
                generalExamHairDistributionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMHAIRDISTRIBUTION:
            return {
                ...state,
                generalExamHairDistributionDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMHAIRTEXTURE:
            return {
                ...state,
                generalExamHairTextureList: action.payload.data,
            }
        case CREATEGENERALEXAMHAIRTEXTURE:
            return {
                ...state,
                generalExamHairTextureSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMHAIRTEXTURE:
            return {
                ...state,
                generalExamHairTextureUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMHAIRTEXTURE:
            return {
                ...state,
                generalExamHairTextureDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMLUBRICATION:
            return {
                ...state,
                generalExamLubricationList: action.payload.data,
            }
        case CREATEGENERALEXAMLUBRICATION:
            return {
                ...state,
                generalExamLubricationSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMLUBRICATION:
            return {
                ...state,
                generalExamLubricationUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMLUBRICATION:
            return {
                ...state,
                generalExamLubricationDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMSCALP:
            return {
                ...state,
                generalExamScalpList: action.payload.data,
            }
        case CREATEGENERALEXAMSCALP:
            return {
                ...state,
                generalExamScalpSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMSCALP:
            return {
                ...state,
                generalExamScalpUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMSCALP:
            return {
                ...state,
                generalExamScalpDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMHEADPOSITION:
            return {
                ...state,
                generalExamHeadPositionList: action.payload.data,
            }
        case CREATEGENERALEXAMHEADPOSITION:
            return {
                ...state,
                generalExamHeadPositionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMHEADPOSITION:
            return {
                ...state,
                generalExamHeadPositionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMHEADPOSITION:
            return {
                ...state,
                generalExamHeadPositionDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMHEADSHAPE:
            return {
                ...state,
                generalExamHeadShapeList: action.payload.data,
            }
        case CREATEGENERALEXAMHEADSHAPE:
            return {
                ...state,
                generalExamHeadShapeSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMHEADSHAPE:
            return {
                ...state,
                generalExamHeadShapeUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMHEADSHAPE:
            return {
                ...state,
                generalExamHeadShapeDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMFACIALFEATURES:
            return {
                ...state,
                generalExamFacialFeaturesList: action.payload.data,
            }
        case CREATEGENERALEXAMFACIALFEATURES:
            return {
                ...state,
                generalExamFacialFeaturesSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMFACIALFEATURES:
            return {
                ...state,
                generalExamFacialFeaturesUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMFACIALFEATURES:
            return {
                ...state,
                generalExamFacialFeaturesDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMEXTERNALEYEPOSITION:
            return {
                ...state,
                generalExamExternalEyeFeaturesList: action.payload.data,
            }
        case CREATEGENERALEXAMEXTERNALEYEPOSITION:
            return {
                ...state,
                generalExamExternalEyeFeaturesSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMEXTERNALEYEPOSITION:
            return {
                ...state,
                generalExamExternalEyeFeaturesUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMEXTERNALEYEPOSITION:
            return {
                ...state,
                generalExamExternalEyeFeaturesDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMLACRIMALAPPARATUS:
            return {
                ...state,
                generalExamLacrimalApparatusList: action.payload.data,
            }
        case CREATEGENERALEXAMLACRIMALAPPARATUS:
            return {
                ...state,
                generalExamLacrimalApparatusSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMLACRIMALAPPARATUS:
            return {
                ...state,
                generalExamLacrimalApparatusUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMLACRIMALAPPARATUS:
            return {
                ...state,
                generalExamLacrimalApparatusDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMCONJUCTIVASCLEARCOLOR:
            return {
                ...state,
                generalExamConjunctivascleracolorList: action.payload.data,
            }
        case CREATEGENERALEXAMCONJUCTIVASCLEARCOLOR:
            return {
                ...state,
                generalExamConjunctivascleracolorSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMCONJUCTIVASCLEARCOLOR:
            return {
                ...state,
                generalExamConjunctivascleracolorUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMCONJUCTIVASCLEARCOLOR:
            return {
                ...state,
                generalExamConjunctivascleracolorDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMEXTRAOCULARMOVEMENTS:
            return {
                ...state,
                generalExamExtraOcularMovementsList: action.payload.data,
            }
        case CREATEGENERALEXAMEXTRAOCULARMOVEMENTS:
            return {
                ...state,
                generalExamExtraOcularMovementsSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMEXTRAOCULARMOVEMENTS:
            return {
                ...state,
                generalExamExtraOcularMovementsUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMEXTRAOCULARMOVEMENTS:
            return {
                ...state,
                generalExamExtraOcularMovementsDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMNECKLYMPHNODE:
            return {
                ...state,
                generalExamNeckLymphNodeList: action.payload.data,
            }
        case CREATEGENERALEXAMNECKLYMPHNODE:
            return {
                ...state,
                generalExamNeckLymphNodeSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMNECKLYMPHNODE:
            return {
                ...state,
                generalExamNeckLymphNodeUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMNECKLYMPHNODE:
            return {
                ...state,
                generalExamNeckLymphNodeDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMGENERALLOOK:
            return {
                ...state,
                generalExamGeneralLookList: action.payload.data,
            }
        case CREATEGENERALEXAMGENERALLOOK:
            return {
                ...state,
                generalExamGeneralLookSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMGENERALLOOK:
            return {
                ...state,
                generalExamGeneralLookUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMGENERALLOOK:
            return {
                ...state,
                generalExamGeneralLookDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMNUTRITION:
            return {
                ...state,
                generalExamNutritionList: action.payload.data,
            }
        case CREATEGENERALEXAMNUTRITION:
            return {
                ...state,
                generalExamNutritionSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMNUTRITION:
            return {
                ...state,
                generalExamNutritionUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMNUTRITION:
            return {
                ...state,
                generalExamNutritionDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMANEAMIA:
            return {
                ...state,
                generalExamAneamiaList: action.payload.data,
            }
        case CREATEGENERALEXAMANEAMIA:
            return {
                ...state,
                generalExamAneamiaSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMANEAMIA:
            return {
                ...state,
                generalExamAneamiaUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMANEAMIA:
            return {
                ...state,
                generalExamAneamiaDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMNECKANDVEIN:
            return {
                ...state,
                generalExamNeckAndVeinList: action.payload.data,
            }
        case CREATEGENERALEXAMNECKANDVEIN:
            return {
                ...state,
                generalExamNeckAndVeinSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMNECKANDVEIN:
            return {
                ...state,
                generalExamNeckAndVeinUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMNECKANDVEIN:
            return {
                ...state,
                generalExamNeckAndVeinDeleteStatus: action.payload.success,
            }
        case GETGENERALEXAMLYMPHNODE:
            return {
                ...state,
                generalExamLymphNodesList: action.payload.data,
            }
        case CREATEGENERALEXAMLYMPHNODE:
            return {
                ...state,
                generalExamLymphNodesSaveStatus: action.payload.success,
            }
        case UPDATEGENERALEXAMLYMPHNODE:
            return {
                ...state,
                generalExamLymphNodesUpdateStatus: action.payload.success,
            }
        case DELETEGENERALEXAMLYMPHNODE:
            return {
                ...state,
                generalExamLymphNodesDeleteStatus: action.payload.success,
            }

        default:
            return state
    }
}